/* eslint-disable react-hooks/exhaustive-deps */

import { Box, Button, Paper, TableContainer, Tooltip, Typography, ToggleButton, ToggleButtonGroup } from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  EMapStatusSale,
  TChashBoxDetails,
  mappingOperations,
  KitchenStatusMap,
  FloorStatusMap,
} from "../common/interfaces";
import { CashBoxService } from "../services/CashBoxService";
import { useLocalStorage } from "../auth/useLocalStorage";
import moment from "moment";
import PrintIcon from "@mui/icons-material/Print";
import ContentPasteSearchIcon from '@mui/icons-material/ContentPasteSearch';
import CancelIcon from "@mui/icons-material/Cancel";
import DeliveryDiningIcon from "@mui/icons-material/DeliveryDining";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

import RefreshIcon from '@mui/icons-material/Refresh';
// import { usePusher } from "../context/pusherContext";
import { v4 } from "uuid";
import { CommonService } from "../services/CommonService";
import { SaleService } from "../services/SaleService";
import Swal from "sweetalert2";
import "@sweetalert2/theme-dark/dark.css";
import withReactContent from "sweetalert2-react-content";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import { useModalStore } from "../context/modalStore";

import { reprintBill } from "./utilsButtons";

const MySwal = withReactContent(Swal);

interface MovementsProps {
  onlyOrders?: boolean;
  reprintOrder: (idVenta: number) => void;
  reprintRPC: (idOperation: number) => void;
  reprintSale: (idVenta: number) => void;
  closeOrder: (idVenta: number) => void;
}

enum OrderType {
  shipped = "A domicilio",
  cocina = "Cocina",
  onSite = "Recoger en Tienda",
  inRoom = "Comedor",
}

// Función para calcular la hora de envío (hora de entrega - 30 minutos)
// Solo aplica para pedidos a domicilio
const calculateSendTime = (deliveryTime: string, shippedType?: number) => {
  if (shippedType === 0) { // 0 = shipped (A domicilio)
    return moment(deliveryTime).subtract(30, 'minutes').format("h:mm A");
  }
  return '-';
};



export const Movements = (props: MovementsProps) => {
  const { reprintOrder, reprintSale, closeOrder, reprintRPC } =
    props;
  const modalManager = useModalStore();
  const onlyOrders = modalManager?.params?.onlyOrders
  // onlyOrders ? 'Pedidos' : 'Movimientos del Día'
  const [rows, setRows] = React.useState<Array<TChashBoxDetails>>(
    [] as TChashBoxDetails[]
  );
  const [user] = useLocalStorage("user", "");
  // const pusher = usePusher();


  const [lastUpdated, setLastUpdated] = useState<Date | null>(null);
  const [isAutoRefreshing, setIsAutoRefreshing] = useState(false);
  const [showDelivered, setShowDelivered] = useState(false);

  // Función para cargar los movimientos manualmente
  const loadMovements = () => {
    if (user && user.cbox && user.cbox.id != null) {
      const orderParam = onlyOrders ? 1 : undefined;
      CashBoxService.getMovements(user.cbox.id, orderParam).then((res) => {
        console.log("📦 Datos recibidos del backend:", res.object);
        // Log específico para pedidos agendados
        const scheduledOrders = (res.object as Array<TChashBoxDetails>).filter(row => row.schedule);
        console.log("📅 Pedidos con schedule:", scheduledOrders);
        setRows(res.object as Array<TChashBoxDetails>);
        setLastUpdated(new Date());
      }).catch((error) => {
        console.error("Error loading movements:", error);
      });
    } else {
      console.log("No cashbox.");
    }
  };

  // Función para auto-refresh con indicador visual
  const autoRefreshMovements = () => {
    if (user && user.cbox && user.cbox.id != null) {
      setIsAutoRefreshing(true);
      const orderParam = onlyOrders ? 1 : undefined;
      CashBoxService.getMovements(user.cbox.id, orderParam).then((res) => {
        console.log("🔄 Auto-refresh - Datos recibidos:", res.object);
        setRows(res.object as Array<TChashBoxDetails>);
        setLastUpdated(new Date());
        setIsAutoRefreshing(false);
      }).catch((error) => {
        console.error("Error loading movements:", error);
        setIsAutoRefreshing(false);
      });
    }
  };

  useEffect(() => {
    modalManager.setTitle(onlyOrders ? "Pedidos" : "Movimientos del Día");

    // Cargar datos inicialmente
    if (user && user.cbox && user.cbox.id != null) {
      const orderParam = onlyOrders ? 1 : undefined;
      CashBoxService.getMovements(user.cbox.id, orderParam).then((res) => {
        setRows(res.object as Array<TChashBoxDetails>);
        setLastUpdated(new Date());
      }).catch((error) => {
        console.error("Error loading movements:", error);
      });
    }
  }, [user, onlyOrders]);

  // Refresh automático cuando se accede a "Pedidos"
  useEffect(() => {
    if (onlyOrders && user && user.cbox && user.cbox.id != null) {
      // Pequeño delay para asegurar que el componente esté completamente montado
      const timeoutId = setTimeout(() => {
        loadMovements();
      }, 100);

      return () => clearTimeout(timeoutId);
    }
  }, [onlyOrders]); // Solo se ejecuta cuando cambia onlyOrders

  // Refresh automático cada minuto para la pantalla de pedidos
  useEffect(() => {
    if (onlyOrders && user && user.cbox && user.cbox.id != null) {
      // Actualizar cada 60 segundos (1 minuto) cuando estemos viendo pedidos
      const intervalId = setInterval(() => {
        autoRefreshMovements();
      }, 60000); // 60000 ms = 1 minuto

      return () => clearInterval(intervalId);
    }
  }, [onlyOrders, user]);

  function cancelOrder(operation_id: number): void {
    const idCancel = v4();
    CommonService.getSaleInfo(operation_id).then((res) => {
      if(res.success){

        CommonService.requestAuthorize({
          message: `Se solicita Cancelar Pedido: ${operation_id}`, // => $req->message,
          action: {
            type: "cancel-order",
            item: { order_id: operation_id },
            id: idCancel,
            content: `Se solicita Cancelar Pedido: <br/> Pedido ${operation_id} <br /> Total: ${res.object?.total} <br /> Productos: <br> ${res.object?.detalles.map(detail => `(${detail.producto.id}) ${detail.producto.name} Cantidad: ${detail.cantidad}`).join('<br>')}`,
          }, // => $req->action,
          status: "pending", // => 'pending', // Set the initial status
          from: user.id, // => $req->from,
          to: 1, // => $req->to,
        }).then((res) => {
          console.log("rquest", { res });
          MySwal.fire({
            icon: "success",
            title: "Se ha solicitado autorización para cancelar el pedido.",
            showConfirmButton: false,
            width: "400px",
            timer: 1500,
          });
        });
      }
    })
  }

  function cancelTransfer(operation_id: number, amount: any): void {
    const idCancel = v4();
    CommonService.requestAuthorize({
      message: `Se solicita Cancelar Traspaso de Inventario: ${operation_id}`, // => $req->message,
      action: {
        type: "cancel-transfer",
        item: { transfer: operation_id },
        id: idCancel,
        content: `Se solicita Cancelar Traspaso de Inventario: ${operation_id} <br />`,
      }, // => $req->action,
      status: "pending", // => 'pending', // Set the initial status
      from: user.id, // => $req->from,
      to: 1, // => $req->to,
    }).then((res) => {
      console.log("rquest", { res });
      MySwal.fire({
        icon: "success",
        title: "Se ha solicitado autorización para cancelar el traspaso de Inventario.",
        showConfirmButton: false,
        width: "400px",
        timer: 1500,
      });
    });
  }

  function createAuth(operation_id: number, amount: string): void {
    const idAuth = v4();
    CommonService.requestAuthorize({
      message: `Se solicita Autorizar un pago por Transferencia de $ ${amount}`, // => $req->message,
      action: {
        type: "authorize-payment",
        item: { order_id: operation_id },
        id: idAuth,
        content: `Se solicita Autorizar un pago por Transferencia de $ ${amount}`,
      }, // => $req->action,
      status: "pending", // => 'pending', // Set the initial status
      from: user.id, // => $req->from,
      to: 1, // => $req->to,
    }).then(() => {
      CommonService.toast("Se envío solicitud de Autorización, para validar pago por transferencia", "success")
      // modalManager.closeModal();
    });
  }

  function deliverToDriver(operation_id: number): void {
    MySwal.fire({
      title: "¿Entregar a repartidor?",
      text: `¿Está seguro que desea marcar el pedido #${operation_id} como entregado al repartidor?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, entregar",
      cancelButtonText: "Cancelar",
      width: "400px",
      focusConfirm: true,
      allowEnterKey: true,
    }).then((result) => {
      if (result.isConfirmed) {
        SaleService.updateOrder(operation_id, "InTransit").then((res) => {
          if (res.success) {
            MySwal.fire({
              icon: "success",
              title: `Pedido #${operation_id} entregado al repartidor`,
              showConfirmButton: false,
              width: "400px",
              timer: 1500,
            });
            // Recargar los movimientos para reflejar el cambio
            loadMovements();
          } else {
            MySwal.fire({
              icon: "error",
              title: "Error",
              text: res.message || "No se pudo entregar el pedido al repartidor",
              width: "400px",
            });
          }
        }).catch((error) => {
          console.error("Error delivering to driver:", error);
          MySwal.fire({
            icon: "error",
            title: "Error",
            text: "Ocurrió un error al entregar el pedido al repartidor",
            width: "400px",
          });
        });
      }
    });
  }

  function markAsDelivered(operation_id: number): void {
    MySwal.fire({
      title: "¿Marcar como entregado?",
      text: `¿Está seguro que desea marcar el pedido #${operation_id} como entregado al cliente?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, marcar como entregado",
      cancelButtonText: "Cancelar",
      width: "400px",
      focusConfirm: true,
      allowEnterKey: true,
    }).then((result) => {
      if (result.isConfirmed) {
        SaleService.updateOrder(operation_id, "Shipped").then((res) => {
          if (res.success) {
            MySwal.fire({
              icon: "success",
              title: `Pedido #${operation_id} marcado como entregado`,
              showConfirmButton: false,
              width: "400px",
              timer: 1500,
            });
            // Recargar los movimientos para reflejar el cambio
            loadMovements();
          } else {
            MySwal.fire({
              icon: "error",
              title: "Error",
              text: res.message || "No se pudo marcar el pedido como entregado",
              width: "400px",
            });
          }
        }).catch((error) => {
          console.error("Error marking as delivered:", error);
          MySwal.fire({
            icon: "error",
            title: "Error",
            text: "Ocurrió un error al marcar el pedido como entregado",
            width: "400px",
          });
        });
      }
    });
  }

  // Payment method mapping
  const paymentMethodMap: Record<string, string> = {
    cash: "Efectivo",
    transfer: "Transferencia",
    debit_card: "Tarjeta de Débito",
    credit_card: "Tarjeta de Crédito",
    gift_card: "Tarjeta de Regalo",
  };

  // Filtrar pedidos según el estado del filtro
  const filteredRows = onlyOrders
    ? showDelivered
      ? rows.filter(row => row.status === "Shipped") // Solo mostrar entregados
      : rows.filter(row => row.status !== "Shipped") // Excluir entregados
    : rows; // Mostrar todos si no es la vista de pedidos

  // Función para determinar el color de fondo de la celda de método de pago
  const getPaymentCellStyle = (row: TChashBoxDetails) => {
    const baseStyle = { borderBottom: "1px solid #ccc", padding: "8px" };

    if (row.payment_status === 'pending') {
      return { ...baseStyle, backgroundColor: '#f15653' }; // Rojo original
    } else if (row.payment_status === 'paid') {
      return { ...baseStyle, backgroundColor: '#239e2e' }; // Verde original
    } else if (row.type === "sale" || row.type === 'out' || row.type === 'transfer_inventory' || row.operation === 'bill') {
      if (!row.payments || row.ss === "pending" || row.operation === 'purchase_orders' || row.status === 'Pendiente') {
        if (row.type === 'transfer_inventory') {
          return row.status === 'Pendiente'
            ? { ...baseStyle, backgroundColor: '#f15653' } // Rojo original
            : { ...baseStyle, backgroundColor: '#239e2e' }; // Verde original
        } else if (row.operation === 'bill') {
          return row.status === 'Pendiente'
            ? { ...baseStyle, backgroundColor: '#f15653' } // Rojo original
            : { ...baseStyle, backgroundColor: '#239e2e' }; // Verde original
        } else {
          return { ...baseStyle, backgroundColor: '#f15653' }; // Rojo original
        }
      } else {
        return { ...baseStyle, backgroundColor: '#239e2e' }; // Verde original
      }
    }

    return baseStyle; // Sin color especial
  };

  // Función para determinar el color de fondo de las celdas de estado (cocina/piso)
  const getStatusCellStyle = (status: string | undefined, originalStatus: string | undefined) => {
    const baseStyle = { borderBottom: "1px solid #ccc", padding: "8px" };

    if (!status || status === "-" || !originalStatus) {
      return baseStyle; // Sin color para guiones o valores vacíos
    }

    // Usar el status original (key) en lugar del texto traducido
    switch (originalStatus) {
      case 'Pending':
      case 'Pendiente':
        return { ...baseStyle, backgroundColor: '#f15653' }; // Rojo

      case 'Cooking':
      case 'OnPrepare':
      case 'Preparing':
        return { ...baseStyle, backgroundColor: '#ff9800' }; // Amarillo/Naranja

      case 'Done':
      case 'Ready':
      case 'Complete':
      case 'Completado':
      case 'Served':
        return { ...baseStyle, backgroundColor: '#239e2e' }; // Verde

      default:
        return baseStyle; // Sin color para otros estados
    }
  };




  return (
    <div>
      {/* <Typography style={{ fontSize: "35px" }}>{onlyOrders ? 'Pedidos' : 'Movimientos del Día'}</Typography> */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="caption" color="text.secondary">
          {lastUpdated ? `Última actualización: ${moment(lastUpdated).format("HH:mm:ss")}` : ""}
          {isAutoRefreshing && " - Actualizando..."}
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          {onlyOrders && (
            <ToggleButtonGroup
              value={showDelivered ? "delivered" : "pending"}
              exclusive
              onChange={(_, newValue) => {
                if (newValue !== null) {
                  setShowDelivered(newValue === "delivered");
                }
              }}
              size="small"
              sx={{ height: '32px' }}
            >
              <ToggleButton value="pending" sx={{ fontSize: '11px', px: 2 }}>
                ACTIVOS
              </ToggleButton>
              <ToggleButton value="delivered" sx={{ fontSize: '11px', px: 2 }}>
                ENTREGADOS
              </ToggleButton>
            </ToggleButtonGroup>
          )}
          <Button
            variant="outlined"
            startIcon={<RefreshIcon />}
            onClick={loadMovements}
            size="small"
            sx={{ fontSize: '12px' }}
            disabled={isAutoRefreshing}
          >
            {isAutoRefreshing ? "Actualizando..." : "Actualizar"}
          </Button>
        </Box>
      </Box>
      <TableContainer component={Paper}>
        <table
          style={{
            width: "100%",
            fontSize: "14px",
            borderCollapse: "collapse",
          }}
        >
          <thead>
            <tr>
              {/* <th style={{width:"10%", borderBottom: "1px solid #ccc"}} align="center">Operacion</th> */}
              <th
                style={{ width: "5%", borderBottom: "1px solid #ccc", padding: "8px" }}
                align="center"
              >
                ID
              </th>
              <th
                style={{ width: "5%", borderBottom: "1px solid #ccc", padding: "8px" }}
                align="center"
              >
                Origen
              </th>
              <th
                style={{ width: "6%", borderBottom: "1px solid #ccc", padding: "8px" }}
                align="center"
              >
                Hora de Registro
              </th>
              <th
                style={{ width: "12%", borderBottom: "1px solid #ccc", padding: "8px" }}
                align="center"
              >
                Cliente
              </th>
              <th
                style={{ width: "6%", borderBottom: "1px solid #ccc", padding: "8px" }}
                align="center"
              >
                Monto
              </th>
              <th
                style={{ width: "7%", borderBottom: "1px solid #ccc", padding: "8px" }}
                align="center"
              >
                Entrega
              </th>
              <th
                style={{ width: "6%", borderBottom: "1px solid #ccc", padding: "8px" }}
                align="center"
              >
                Hora de Envío
              </th>
              <th
                style={{ width: "6%", borderBottom: "1px solid #ccc", padding: "8px" }}
                align="center"
              >
                Hora de Entrega
              </th>
              <th
                style={{ width: "7%", borderBottom: "1px solid #ccc", padding: "8px" }}
                align="center"
              >
                Estatus
              </th>
              <th
                style={{ width: "7%", borderBottom: "1px solid #ccc", padding: "8px" }}
                align="center"
              >
                Estatus Cocina
              </th>
              <th
                style={{ width: "7%", borderBottom: "1px solid #ccc", padding: "8px" }}
                align="center"
              >
                Estatus Piso
              </th>
              <th
                style={{ width: "5%", borderBottom: "1px solid #ccc", padding: "8px" }}
                align="center"
              >
                Envío
              </th>

              <th
                style={{ width: "9%", borderBottom: "1px solid #ccc", padding: "8px" }}
                align="center"
              >
                Método de Pago
              </th>
              <th
                style={{ width: "18%", borderBottom: "1px solid #ccc", padding: "8px" }}
                align="center"
              >
                Acciones
              </th>
            </tr>
          </thead>
          <tbody>
            {filteredRows.map((row, i) => (
              <tr
                key={i}
                style={{ borderBottom: "1px solid #ccc" }}
              >
                {/* <td align="center" style={{borderBottom: "1px solid #ccc"}}>
                {row.operation}
              </td> */}
                <td align="center" style={{ borderBottom: "1px solid #ccc", padding: "8px" }}>
                  {mappingOperations[row.operation].code + row.operation_id}
                </td>
                <td align="center" style={{ borderBottom: "1px solid #ccc", padding: "8px" }}>
                  {row.origin_by === "WEB-POS" ? `WEB-${row.alias_id}` : row.origin_by}
                </td>
                <td align="center" style={{ borderBottom: "1px solid #ccc", padding: "8px" }}>
                  {moment(row.created_at).format("h:mm A")}
                </td>
                <td align="center" style={{ borderBottom: "1px solid #ccc", padding: "8px" }}>
                  <Tooltip title={<Typography fontSize={30}>{row.telefono || "Teléfono no disponible"}</Typography>} arrow>
                    <span>{row.nombre === "P\u00daBLICO EN GENERAL" ? "" : row.nombre}</span>
                  </Tooltip>
                  {/* {row.nombre === "P\u00daBLICO EN GENERAL" ? "" : row.nombre} */}
                </td>
                <td align="center" style={{ borderBottom: "1px solid #ccc", padding: "8px" }}>
                  {row.amount}
                </td>
                {/* <td align="right" style={{ borderBottom: "1px solid #ccc" }}>
                  {mappingOperations[row.operation].label}
                </td> */}
                <td align="center" style={{ borderBottom: "1px solid #ccc", padding: "8px" }}>
                  {OrderType[
                    row.domicilio as unknown as keyof typeof OrderType
                  ] ?? "Regular"}
                </td>
                <td align="center" style={{ borderBottom: "1px solid #ccc", padding: "8px" }}>
                  {row.schedule ? calculateSendTime(row.schedule, row.domicilio) : "-"}
                </td>
                <td align="center" style={{ borderBottom: "1px solid #ccc", padding: "8px" }}>
                  {row.schedule ? moment(row.schedule).format("h:mm A") : "-"}
                </td>
                <td align="center" style={{ borderBottom: "1px solid #ccc", padding: "8px" }}>
                  {row.ss === "pending"
                    ? "Esperando Autorización"
                    : EMapStatusSale[row.status as keyof typeof EMapStatusSale]}
                </td>
                <td align="center" style={getStatusCellStyle(
                  (row.status === "Shipped" || row.status === "InTransit") ? "-" : (row.kitchen_status ? KitchenStatusMap[row.kitchen_status] || row.kitchen_status : "-"),
                  (row.status === "Shipped" || row.status === "InTransit") ? "-" : row.kitchen_status
                )}>
                  {(row.status === "Shipped" || row.status === "InTransit") ? "-" : (row.kitchen_status ? KitchenStatusMap[row.kitchen_status] || row.kitchen_status : "-")}
                </td>
                <td align="center" style={getStatusCellStyle(
                  (row.status === "Shipped" || row.status === "InTransit") ? "-" : (row.floor_status ? FloorStatusMap[row.floor_status] || row.floor_status : "-"),
                  (row.status === "Shipped" || row.status === "InTransit") ? "-" : row.floor_status
                )}>
                  {(row.status === "Shipped" || row.status === "InTransit") ? "-" : (row.floor_status ? FloorStatusMap[row.floor_status] || row.floor_status : "-")}
                </td>
                <td align="center" style={{ borderBottom: "1px solid #ccc", padding: "8px" }}>
                  {row.shipping && row.shipping > 0 ? `$${row.shipping}` : ""}
                </td>
                <td align="center" style={getPaymentCellStyle(row)}>
                  {paymentMethodMap[row.payment_method ?? "cash"]}
                </td>
                <td
                  align="center"
                  style={{
                    borderBottom: "1px solid #ccc",
                    padding: "8px",
                  }}
                  hidden={row.operation === "venta"}
                >
                  {row.operation === "purchase_orders_receipt" && (
                    <Button
                      title="Imprimir Ticket"
                      style={{
                        fontSize: "10px",
                        width: "35px",
                        minWidth: "auto",
                        margin: "2px",
                      }}
                      variant="contained"
                      size="small"
                      color="success"
                      onClick={() => reprintRPC(row.operation_id)}
                    >
                      <PrintIcon />
                    </Button>
                  )}
                  {
                    row.operation === 'warehouse_transfer' && row.status === 'Pendiente' && (
                      <Button
                        title="Cancelar Traspaso"
                        style={{
                          fontSize: "10px",
                          width: "35px",
                          minWidth: "auto",
                          margin: "2px",
                        }}
                        variant="contained"
                        size="small"
                        color="error"
                        onClick={() => cancelTransfer(row.operation_id, row.amount)}
                      >
                        <CancelIcon />
                      </Button>
                    )
                  }

                  {
                    row.operation === 'bill' && row.status === 'Complete' && (
                      <Button
                      title="Imprimir Ticket"
                      style={{
                        fontSize: "10px",
                        width: "35px",
                        minWidth: "auto",
                        margin: "2px",
                      }}
                      variant="contained"
                      size="small"
                      color="info"
                      onClick={() => reprintBill(row.operation_id)}
                    >
                      <PrintIcon />
                    </Button>
                    )
                  }
                </td>
                <td
                  align="center"
                  style={{
                    borderBottom: "1px solid #ccc",
                    padding: "8px",
                  }}
                  hidden={row.operation !== "venta"}
                >
                  {row.sale_type === "Order" && (
                    <Button
                      title="Imprimir Comanda"
                      style={{
                        fontSize: "10px",
                        width: "35px",
                        minWidth: "auto",
                        margin: "2px",
                      }}
                      variant="contained"
                      size="small"
                      color="success"
                      onClick={() => reprintOrder(row.operation_id)}
                    >
                      <ContentPasteSearchIcon />
                    </Button>
                  )}
                  {row.payment_status === "paid" && (
                    <>
                      <Button
                        title="Imprimir Ticket"
                        style={{
                          fontSize: "10px",
                          width: "35px",
                          minWidth: "auto",
                          margin: "2px",
                        }}
                        variant="contained"
                        size="small"
                        color="info"
                        onClick={() => reprintSale(row.operation_id)}
                      >
                        <PrintIcon />
                      </Button>
                      {OrderType[row.domicilio as unknown as keyof typeof OrderType] === "A domicilio" && row.status !== "Shipped" && row.status !== "InTransit" && (
                        <Button
                          title="Entregar a Repartidor"
                          style={{
                            fontSize: "10px",
                            width: "35px",
                            minWidth: "auto",
                            margin: "2px",
                          }}
                          variant="contained"
                          size="small"
                          color="warning"
                          onClick={() => deliverToDriver(row.operation_id)}
                        >
                          <DeliveryDiningIcon />
                        </Button>
                      )}
                      {OrderType[row.domicilio as unknown as keyof typeof OrderType] === "A domicilio" && row.status === "InTransit" && (
                        <Button
                          title="Marcar como Entregado"
                          style={{
                            fontSize: "10px",
                            width: "35px",
                            minWidth: "auto",
                            margin: "2px",
                          }}
                          variant="contained"
                          size="small"
                          color="success"
                          onClick={() => markAsDelivered(row.operation_id)}
                        >
                          <CheckCircleIcon />
                        </Button>
                      )}
                      {OrderType[row.domicilio as unknown as keyof typeof OrderType] === "Recoger en Tienda" && (row.status === "Done" || row.status === "Pending") && (
                        <Button
                          title="Marcar como Entregado"
                          style={{
                            fontSize: "10px",
                            width: "35px",
                            minWidth: "auto",
                            margin: "2px",
                          }}
                          variant="contained"
                          size="small"
                          color="success"
                          onClick={() => markAsDelivered(row.operation_id)}
                        >
                          <CheckCircleIcon />
                        </Button>
                      )}
                      {OrderType[row.domicilio as unknown as keyof typeof OrderType] === "Comedor" && (row.status === "Done" || row.status === "Pending") && (
                        <Button
                          title="Marcar como Entregado"
                          style={{
                            fontSize: "10px",
                            width: "35px",
                            minWidth: "auto",
                            margin: "2px",
                          }}
                          variant="contained"
                          size="small"
                          color="success"
                          onClick={() => markAsDelivered(row.operation_id)}
                        >
                          <CheckCircleIcon />
                        </Button>
                      )}
                    </>
                  )}
                  {row.payment_status === "pending" && row.ss !== "pending" && (
                    <>
                      <Button
                        title="Pagar Pedido"
                        style={{
                          fontSize: "10px",
                          width: "35px",
                          minWidth: "auto",
                          margin: "2px",
                        }}
                        variant="contained"
                        size="small"
                        color="primary"
                        onClick={() => closeOrder(row.operation_id)}
                      >
                        <AttachMoneyIcon />
                      </Button>
                      <Button
                        title="Cancelar Pedido"
                        style={{
                          fontSize: "10px",
                          width: "35px",
                          minWidth: "auto",
                          margin: "2px",
                        }}
                        variant="contained"
                        size="small"
                        color="error"
                        onClick={() => cancelOrder(row.operation_id)}
                      >
                        <CancelIcon />
                      </Button>
                    </>
                  )}
                  {row.ss === "pending" && (
                    <>
                      <Button
                        title="Reenviar Solicitud de Aprobación"
                        style={{
                          fontSize: "10px",
                          width: "35px",
                          minWidth: "auto",
                          margin: "2px",
                        }}
                        variant="contained"
                        size="small"
                        color="primary"
                        onClick={() => createAuth(row.operation_id, row.amount)}
                      >
                        <AttachMoneyIcon />
                      </Button>
                      <Button
                        title="Cancelar Pedido"
                        style={{
                          fontSize: "10px",
                          width: "35px",
                          minWidth: "auto",
                          margin: "2px",
                        }}
                        variant="contained"
                        size="small"
                        color="error"
                        onClick={() => cancelOrder(row.operation_id)}
                      >
                        <CancelIcon />
                      </Button>
                    </>
                  )}


                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </TableContainer>


    </div>
  );
};
